import request from '@/utils/request'

const mealTonic = {
  // 查询加班餐补人员列表
  listMealTonic(query) {
    return request({
      url: '/admi/overtimeStatisticsUser/list',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '加载中...'
      }
    })
  },
  // 查询【加班餐补明细】列表
  getMealTonic(query) {
    return request({
      url: '/admi/overTimeStatisticsDetail/list',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '加载中...'
      }
    })
  },
  // // 查询【加班餐补明细】详情
  // getMealTonic(id) {
  //   return request({
  //     url: '/admi/overTimeStatisticsDetail/' + id,
  //     method: 'get',
  //     options: {
  //       loading: true,
  //       loadingText: '加载中...'
  //     }
  //   })
  // },
  // // 加班餐补上报
  // addMealTonic(data) {
  //   return request({
  //     url: '/admi/overTimeStatisticsDetail',
  //     method: 'post',
  //     data: data,
  //     options: {
  //       loading: true
  //     }
  //   })
  // },
  // 加班餐补确认
  confirmMealTonic(data) {
    return request({
      url: '/admi/overTimeStatisticsDetail/confirm',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '加载中...'
      }
    })
  },
  // 查询【加班餐补主表】列表
  listMealTonicMain(query) {
    return request({
      url: '/admi/overTimeStatistics/list',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '加载中...'
      }
    })
  },
  // 查询【加班餐补主表】详情
  getMealTonicMain(id) {
    return request({
      url: '/admi/overTimeStatistics/' + id,
      method: 'get',
      options: {
        loading: true,
        loadingText: '加载中...'
      }
    })
  },
  // 加班餐补主表审核
  auditMealTonicMain(data) {
    return request({
      url: '/admi/overTimeStatistics/confirm',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 获取各个事业部
  getDeptList (query) {
    return request({
      url: 'system/dept/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 加班餐补批量确认
  batchConfirmMealTonic(data) {
    return request({
      url: '/admi/overTimeStatisticsDetail/confirmAll',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 加班餐补批量不通过
  batchFailMealTonic(data) {
    return request({
      url: '/admi/overTimeStatisticsDetail/notConfirmAll',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  }
}
export default mealTonic
